<template>
  <div class="btn"
    @click="$vuetify.goTo(scrollTarget, scrollOptions)"
  >
    <div class="img">
      <img src="/images/pfeil_nach_unten.svg" />
    </div>
    <div class="text">
      Jetzt unverbindliche Beratung Anfordern!
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      scrollOptions: {
        duration: 500,
        offset: 0,
        easing: 'easeInOutCubic'
      },
      scrollTarget: '#kontakt'
    }
  }
}
</script>

<style scoped lang="scss">
  .btn {
    display: flex;
    max-width: 353px;
    width: 100%;
    border: 3px solid #FFFFFF;
    border-radius: 36px;
    background-color: #f49e00;
    box-shadow: 0 5px 5px #00000029;
    padding: 13px 41px 13px 20px;
    margin: 35px auto 4.889rem auto;

    &:hover {
      cursor: pointer;
    }

    .img {
      display: flex;
    }

    .text {
      text-align: center;
      text-transform: uppercase;
      color: white;
      text-shadow: 0 3px 6px #00000029;
      font-weight: bold;
      letter-spacing: .4px;
      line-height: 1.222rem;
      font-size: 1.111rem;
      padding-left: 10px;
    }
  }

  @media screen and (max-width: 360px) {
    .btn {
      flex-direction: column-reverse;
      padding: 13px 20px;

      .text {
        padding-left: 0;
      }

      img {
        margin: 1rem auto 0 auto;
      }
    }
  }
</style>
